/**
 * Drapeaux du perimetre MVP du portail (S62, 1er-2 sept 2026).
 *
 * Vision MVP (arbitrage Daniel) : un producteur se connecte, rejoint un
 * evenement et y presente ses produits (+ presentation, photo) ; un client
 * voit les evenements, les producteurs presents et ce qu'ils vendent.
 * TOUT LE RESTE EST MASQUE, pas supprime : chaque drapeau ci-dessous coupe une
 * fonctionnalite complete (menus, cartes, route). Reouvrir = passer a `true`.
 *
 * Regles :
 *  - une page masquee n'est pas seulement retiree des menus : sa route
 *    REDIRIGE vers l'accueil (un ancien lien ne tombe jamais sur un ecran vide) ;
 *  - aucun controle « Bientot » : une entree fonctionne, ou elle n'existe pas.
 */
export const MVP = {
  // Assistant : la carte RINA reste l'en-tete explicatif des pages, sans lien
  // ni page de conversation.
  RINA_CHAT: false,

  // Wallet (pastille du header, carte du Compte, page /wallet, recharge carte).
  // Webhook Stripe non configure en prod : une recharge serait debitee sans credit.
  WALLET: false,

  // Module Paniers (tournees) — facette client ET producteur.
  PANIERS: false,

  // Pages du Compte faites uniquement de reglages « Bientot ».
  PARAMETRES: false,
  NOTIFICATIONS: false,

  // Espace producteur hors MVP (Marche, Offres et Profil producteur restent).
  // « Mon activite » et « Ma facturation » rouverts dans Mon compte, casquette
  // producteur (demande Enzo, S71, 10 sept).
  PRODUCTEUR_ACTIVITE: true,
  PRODUCTEUR_ORGANISATION: false,
  PRODUCTEUR_FACTURATION: true,
  PRODUCTEUR_PAIEMENTS: false,
  // Onglet Historique du Marche producteur (declaration de CA, commission,
  // reglement). Rouvert avec « Ma facturation » (demande Enzo, S71) : c'est
  // la page que « Gerer › » ouvre, comme dans le prototype (mHistoP).
  PRODUCTEUR_HISTORIQUE: true,

  // Bascule de casquette dans le menu de la pastille du header. « Devenir
  // producteur » ne vit que dans la page Compte.
  DEVENIR_PRODUCTEUR_HEADER: false,

  // Ecran d'intro immersif a chaque visite (sinon : premiere visite seulement).
  INTRO_CHAQUE_VISITE: false,

  // Navigation d'un CLIENT SIMPLE (compte sans casquette producteur) — retours
  // Daniel 1er sept : pas de barre basse, la pastille du header devient un
  // bouton reglages qui ouvre le Compte, et le Compte a un bouton « Retour ».
  BARRE_CLIENT: false,
  // Onglets Explorer (grille des lieux) et Favoris cote client : inutiles tant
  // qu'il n'y a qu'un lieu et pas d'annuaire ; les etoiles suivent FAVORIS.
  EXPLORER_CLIENT: false,
  FAVORIS: false,

  // Cote PRODUCTEUR (S62, retours Daniel) : l'onglet Explorer (grille des lieux)
  // devient un onglet « Évènements » qui ouvre directement le module ; le feed
  // « En ce moment » de l'accueil disparait (Offres est deja dans la barre).
  // Retour au prototype (Enzo, S72, 14 sept) : barre Accueil / Explorer /
  // Offres / Compte ; l'Explorer ouvre chaque module (les autres arrivent).
  EXPLORER_PRODUCTEUR: true,
  ACCUEIL_PRODUCTEUR_FEED: false,
  // « Ma page » (la fiche telle que le client la voit) devient un onglet de la
  // barre producteur ; le Compte sort de la barre (accessible par la pastille
  // du header → « Voir mon compte »). Repasser a true pour retrouver Compte.
  // S72 : le Compte revient dans la barre (prototype) ; « Ma page » devient une
  // ligne de Mon compte.
  COMPTE_DANS_BARRE_PRODUCTEUR: true,
  // Le Marche producteur en MODULE PLEIN ECRAN (sa propre barre Événements /
  // Mon stand). Faux : ses ecrans vivent dans le hub — onglet Évènements
  // (/producteur/marches) + sous-page Mon stand (/producteur/stand) — avec la
  // barre normale. Retour Daniel : « ça m'envoie sur une autre navbar ».
  // S72 (Enzo) : de retour au module plein ecran du prototype — sa barre
  // Événements / Mon stand / Historique.
  MARCHE_PRODUCTEUR_PLEIN_ECRAN: true,

  // Relances « il manque votre email » (bandeau du Compte, badge « A completer »,
  // bandeau du Profil) : la connexion est par telephone + PIN, l'email n'est
  // pas necessaire au MVP.
  EMAIL_REQUIS: false,
  // Lignes Email / Mot de passe « Bientot » de la page Securite.
  AUTH_EMAIL_MDP: false,

  // Toggle Web2/Web3 en haut de l'ecran d'intro (« 50 % / 100 % souverain ») :
  // illisible pour un client, et le theme sombre double la surface de QA.
  THEME_TOGGLE: false,

  // Dossier exposant (S73, prototype v7.5, ADR-071) : page /account/dossier,
  // rappel dans la bulle RINA, ligne de Mon compte, encadre de la confirmation
  // de stand, carte d'accueil « en verification ». Faux = tout disparait (la
  // route redirige), sans « Bientot » : c'est une campagne, pas une annonce.
  DOSSIER_EXPOSANT: true,
}
